import React from 'react';
import data from '../../data/home1/blogs';

function Blog() {
  return (
    <section className="tc-blog-style1 modern-blog">
      <div className="container">

        {/* HEADER */}
        <div className="mb-60 text-center">
          <h2 className="section-title">Latest Blog Posts</h2>
        </div>

        {/* SLIDER */}
        <div className="blog-slider position-relative overflow-hidden">
          <div className="swiper-wrapper">

            {data.map((item, i) => (
              <div key={i} className="swiper-slide">

                <div className="blog-card modern-card">

                  {/* IMAGE */}
                  <div className="img">
                    <img src={item.img} alt="" />
                  </div>

                  {/* CONTENT */}
                  <div className="info">

                    {/* DATE */}
                    <div className="date modern-date">
                      {/* <span className="num">{item.num}</span> */}
                      <small>
                        {item.history.split('<br />')[0]}
                      </small>
                    </div>

                    {/* TITLE */}
                    <a href="/innerpages/blog" className="title">
                      {item.title}
                    </a>

                  </div>

                </div>

              </div>
            ))}

          </div>
        </div>

        {/* BOTTOM CONTROLS */}
        <div className="slider-controls">

          <div className="swiper-button-prev modern-arrow"></div>

          <a href="/innerpages/blog" className="modern-btn">
            View All Blogs
          </a>

          <div className="swiper-button-next modern-arrow"></div>

        </div>

      </div>
    </section>
  );
}

export default Blog;